/*
 * BRICS Sustainable Lifestyle Week (BSLW) 2026.
 *
 * The week runs 1-7 Nov 2026 (IST). Inside BRICS_WINDOW the form is live: the
 * post-login prompt, the school dashboard card and the public page all offer
 * it. Outside it the prompt and the card are gone and the page says the form
 * is closed. The backend accepts submissions only inside the same window
 * (DEFAULT_BRICS_OPEN_FROM / DEFAULT_BRICS_OPEN_UNTIL, or BRICS_OPEN_FROM /
 * BRICS_OPEN_UNTIL in Backend2) — change both together.
 *
 * BRICS_ENABLED is the kill switch: set it to false to pull the week from the
 * school experience without waiting for the window to end.
 *
 * `?bricspreview=1` on any page makes the form live for that browser tab
 * (sessionStorage) so it can be reviewed before 1 Nov. Submissions still
 * follow the server's window and will be refused with BRICS_CLOSED.
 */

export const BRICS_ENABLED = true;

export const BRICS_WINDOW = {
  from: "2026-11-01T00:00:00+05:30",
  until: "2026-11-08T00:00:00+05:30",
};

// Public page (no login) and the same form inside the school dashboard.
export const BRICS_PATH = "/brics-sustainable-lifestyle-week";
export const BRICS_SCHOOL_PATH = "/school/brics-sustainable-lifestyle-week";

export const BRICS_CAMPAIGN = "BRICS Sustainable Lifestyle Week";
export const BRICS_SHORT = "BRICS Sustainable Lifestyle Week";
export const BRICS_DATES = "1-7 November 2026";
export const BRICS_TITLE = "Save Energy & Adopt a Healthy Lifestyle";
export const BRICS_LIVE_CAPTION = "This form will be live from 01.11.2026";

// The two initiatives, in the order the form shows them.
export const BRICS_INITIATIVES = [
  { key: "saveEnergy", title: "Save Energy" },
  { key: "adoptHealthyLifestyle", title: "Adopt Healthy Lifestyle" },
];

const PREVIEW_KEY = "brics_preview";

const previewOn = () => {
  try {
    const q = new URLSearchParams(window.location.search).get("bricspreview");
    if (q === "1") window.sessionStorage.setItem(PREVIEW_KEY, "1");
    if (q === "0") window.sessionStorage.removeItem(PREVIEW_KEY);
    return window.sessionStorage.getItem(PREVIEW_KEY) === "1";
  } catch (e) {
    return false;
  }
};

export const isBricsLive = (now = Date.now()) => {
  if (!BRICS_ENABLED) return false;
  const from = Date.parse(BRICS_WINDOW.from);
  const until = Date.parse(BRICS_WINDOW.until);
  return (now >= from && now < until) || previewOn();
};

// Before the week (and not previewing): the page is shown, not filled.
export const isBricsViewOnly = (now = Date.now()) =>
  BRICS_ENABLED && now < Date.parse(BRICS_WINDOW.from) && !previewOn();

// Landing-page highlight: from now until the week ends.
export const isBricsShown = (now = Date.now()) => isBricsViewOnly(now) || isBricsLive(now);

export const isBricsClosed = (now = Date.now()) =>
  !BRICS_ENABLED || now >= Date.parse(BRICS_WINDOW.until);
